import styled, { css } from 'styled-components';
import { Icon } from '@elfsight/lib-icon';

export const ShadowIcon = styled(Icon)<{
  // Можно убрать после внедрения статичных классов (помогает определять тип источника у иконки)
  alt?: string;
  _shadow?: boolean;
}>`
  & svg {
    ${({ _shadow }) =>
      _shadow &&
      css`
        filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.4));
      `}
  }
`;
